/*
 * Author:wangjiao
 * Description: geoserver工作空间基础信息初始化和维护工具
 * Date: Create in 2021-01-28 16:15:35
 */

import axios from 'axios'
import {
    helper
} from './tools'

const Init = {
    options: {
        namespace_url: 'http://geoserver.org/',
        GEOField: 'geom',
        srs: 'EPSG:3857',
        srs_content: "PROJCS[\"WGS 84 / Pseudo-Mercator\", \n  GEOGCS[\"WGS 84\", \n    DATUM[\"World Geodetic System 1984\", \n      SPHEROID[\"WGS 84\", 6378137.0, 298.257223563, AUTHORITY[\"EPSG\",\"7030\"]], \n      AUTHORITY[\"EPSG\",\"6326\"]], \n    PRIMEM[\"Greenwich\", 0.0, AUTHORITY[\"EPSG\",\"8901\"]], \n    UNIT[\"degree\", 0.017453292519943295], \n    AXIS[\"Geodetic longitude\", EAST], \n    AXIS[\"Geodetic latitude\", NORTH], \n    AUTHORITY[\"EPSG\",\"4326\"]], \n  PROJECTION[\"Popular Visualisation Pseudo Mercator\"], \n  PARAMETER[\"semi_minor\", 6378137.0], \n  PARAMETER[\"latitude_of_origin\", 0.0], \n  PARAMETER[\"central_meridian\", 0.0], \n  PARAMETER[\"scale_factor\", 1.0], \n  PARAMETER[\"false_easting\", 0.0], \n  PARAMETER[\"false_northing\", 0.0], \n  UNIT[\"m\", 1.0], \n  AXIS[\"Easting\", EAST], \n AXIS[\"Northing\", NORTH], \n AUTHORITY[\"EPSG\",\"3857\"]]",
        nativeBoundingBox: {
            "minx": -20037508,
            "maxx": 20037508,
            "miny": -20048966,
            "maxy": 20048966,
            "crs": "EPSG:3857"
        },
        latLonBoundingBox: {
            "minx": -180,
            "maxx": 180,
            "miny": -90,
            "maxy": 90,
            "crs": "EPSG:4326"
        },
        layers: [{
            name: "jmline",
            title: '管线',
            style: 'line',
            geotype: "org.locationtech.jts.geom.MultiLineString",
            attribute: [{
                    name: "subtype",
                    datatype: "java.lang.String",
                    alias: "类型",
                    length: 50,
                }, {
                    name: "status",
                    datatype: "java.lang.String",
                    alias: "状态",
                    length: 10,
                }, {
                    name: "color",
                    datatype: "java.lang.String",
                    alias: "颜色",
                    length: 100,
                }, {
                    name: "size",
                    datatype: "java.lang.String",
                    alias: "尺寸",
                    length: 10,
                }, {
                    name: "zindex",
                    datatype: "java.lang.Integer",
                    alias: "层级",
                }, {
                    "name": "ADDR",
                    "alias": "地址",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "ASSEMBLER",
                    "alias": "施工单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "AVGHGT",
                    "alias": "平均埋深",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "BUILDDATA",
                    "alias": "修建日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "BUILDDEPT",
                    "alias": "建设单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "BURY_STYLE",
                    "alias": "埋设方式",
                    "datatype": "java.lang.String",
                    "length": 12
                },
                {
                    "name": "CHANGEDATE",
                    "alias": "修改日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "CHECKPERSON",
                    "alias": "审核人",
                    "datatype": "java.lang.String",
                    "length": 40
                },
                {
                    "name": "CODE",
                    "alias": "设备编码",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DESIGNDEPT",
                    "alias": "设计单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DESIGNNO",
                    "alias": "设计编号",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DESPRESSURE",
                    "alias": "设计压力",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "DETECTDATE",
                    "alias": "探测时间",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "DETECTUNIT",
                    "alias": "探测单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DFIXEDYEAR",
                    "alias": "设计服务年限",
                    "datatype": "java.lang.Integer",
                },
                {
                    "name": "DIAMETER",
                    "alias": "管径",
                    "datatype": "java.lang.Integer",
                },
                {
                    "name": "DISTNO",
                    "alias": "图幅号",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "DISTRICT_XZQ",
                    "alias": "所在区县",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DRAWNAME",
                    "alias": "工程名称",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "DRAWNO",
                    "alias": "工程编号",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "EDITPERSON",
                    "alias": "修改人",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "END_DEPTH",
                    "alias": "终点埋深",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "END_HEIGHT",
                    "alias": "终点高程",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "END_SID",
                    "alias": "终点点号",
                    "datatype": "java.lang.String",
                    "length": 30
                },
                {
                    "name": "EXPLORERS",
                    "alias": "探测人员",
                    "datatype": "java.lang.String",
                    "length": 40
                },
                {
                    "name": "FINISHDATE",
                    "alias": "竣工日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "GASDATE",
                    "alias": "投运日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "LANE_WAY",
                    "alias": "所属道路",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "MANUFACTURER",
                    "alias": "生产厂家",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "MATERIAL",
                    "alias": "材质",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "OWNERDEPT",
                    "alias": "权属单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "PIPE_CLASS",
                    "alias": "管线类别",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "PIPE_NAME",
                    "alias": "管线名称",
                    "datatype": "java.lang.String",
                    "length": 30
                },
                {
                    "name": "PIPE_STATUS",
                    "alias": "管线状态",
                    "datatype": "java.lang.String",
                    "length": 4
                },
                {
                    "name": "PIPECHAR",
                    "alias": "工程性质",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "PIPELENGTH",
                    "alias": "长度",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "PRESSURELEVEL",
                    "alias": "压力级制",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "PROJNO_TD",
                    "alias": "项目编号",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "REMARK",
                    "alias": "备注",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "RUNDATE",
                    "alias": "运行时间",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "RUNPRESSURE",
                    "alias": "运行压力",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "RUNSTATUS",
                    "alias": "工作状态",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "SID",
                    "alias": "编号",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "SPEC",
                    "alias": "规格型号",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "START_DEPTH",
                    "alias": "起点埋深",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "START_HEIGHT",
                    "alias": "起点高程",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "START_SID",
                    "alias": "起点点号",
                    "datatype": "java.lang.String",
                    "length": 30
                },
                {
                    "name": "STATUS_D",
                    "alias": "设施状态",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "STATUS_C",
                    "alias": "开关状态",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "SUBTYPE_D",
                    "alias": "特征",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "SUPERVISER",
                    "alias": "监理单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "SUPERVISOR",
                    "alias": "监理人员",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "THICK",
                    "alias": "壁厚",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "WRITEDATE",
                    "alias": "录入日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "WRITEPERSON",
                    "alias": "录入人",
                    "datatype": "java.lang.String",
                    "length": 40
                }
            ]
        }, {
            name: "jmpoint",
            title: '管点',
            style: 'point',
            geotype: "org.locationtech.jts.geom.Point",
            attribute: [{
                    name: "subtype",
                    datatype: "java.lang.String",
                    alias: "类型",
                    length: 50,
                }, {
                    name: "status",
                    datatype: "java.lang.String",
                    alias: "状态",
                    length: 10,
                }, {
                    name: "color",
                    datatype: "java.lang.String",
                    alias: "颜色",
                    length: 10,
                }, {
                    name: "size",
                    datatype: "java.lang.String",
                    alias: "尺寸",
                    length: 10,
                }, {
                    name: "zindex",
                    datatype: "java.lang.Integer",
                    alias: "层级",
                }, {
                    name: "angle",
                    datatype: "java.lang.Float",
                    alias: "角度",
                }, {
                    "name": "ADDR",
                    "alias": "地址",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "ASSEMBLER",
                    "alias": "施工单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "BUILDDATA",
                    "alias": "修建日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "BUILDDEPT",
                    "alias": "建设单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "BURY_STYLE",
                    "alias": "埋设方式",
                    "datatype": "java.lang.String",
                    "length": 12
                },
                {
                    "name": "CHANGEDATE",
                    "alias": "修改日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "CHECKPERSON",
                    "alias": "审核人",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "CODE",
                    "alias": "设备编码",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DEPTH",
                    "alias": "埋深",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "DESIGNDEPT",
                    "alias": "设计单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DESIGNNO",
                    "alias": "设计编号",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DESPRESSURE",
                    "alias": "设计压力",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "DETECTDATE",
                    "alias": "探测时间",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "DETECTUNIT",
                    "alias": "探测单位",
                    "datatype": "java.lang.String",
                    "length": 40
                },
                {
                    "name": "DFIXEDYEAR",
                    "alias": "设计服务年限",
                    "datatype": "java.lang.Integer",
                },
                {
                    "name": "DIAMETER",
                    "alias": "管径",
                    "datatype": "java.lang.Integer",
                },
                {
                    "name": "DISTNO",
                    "alias": "图幅号",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "DISTRICT_XZQ",
                    "alias": "所在区县",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "DRAWNAME",
                    "alias": "工程名称",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "DRAWNO",
                    "alias": "工程编号",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "EDITPERSON",
                    "alias": "修改人",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "EXPLORERS",
                    "alias": "探测人员",
                    "datatype": "java.lang.String",
                    "length": 40
                },
                {
                    "name": "FACTORYDATE",
                    "alias": "出厂日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "FINISHDATE",
                    "alias": "竣工日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "GASDATE",
                    "alias": "投运日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "HEIGHT",
                    "alias": "地面高程",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "LANE_WAY",
                    "alias": "所属道路",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "MATERIAL",
                    "alias": "材质",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "OWNERDEPT",
                    "alias": "权属单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "PIPE_CLASS",
                    "alias": "管线类别",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "PIPE_NAME",
                    "alias": "管线名称",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "PIPECHAR",
                    "alias": "工程性质",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "PRESSURELEVEL",
                    "alias": "压力级制",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "PROJNO_TD",
                    "alias": "项目编号",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "REMARK",
                    "alias": "备注",
                    "datatype": "java.lang.String",
                    "length": 100
                },
                {
                    "name": "RUNDATE",
                    "alias": "运行时间",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "RUNPRESSURE",
                    "alias": "运行压力",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "RUNSTATUS",
                    "alias": "工作状态",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "SID",
                    "alias": "点号",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "SPEC",
                    "alias": "规格型号",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "STATUS_C",
                    "alias": "开关状态",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "STATUS_D",
                    "alias": "设施状态",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "SUBTYPE_D",
                    "alias": "特征",
                    "datatype": "java.lang.String",
                    "length": 20
                },
                {
                    "name": "SUPERVISER",
                    "alias": "监理单位",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "SUPERVISOR",
                    "alias": "监理人员",
                    "datatype": "java.lang.String",
                    "length": 255
                },
                {
                    "name": "WRITEDATE",
                    "alias": "录入日期",
                    "datatype": "java.sql.Date",
                },
                {
                    "name": "WRITEPERSON",
                    "alias": "录入人",
                    "datatype": "java.lang.String",
                    "length": 50
                },
                {
                    "name": "X",
                    "alias": "横坐标",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "Y",
                    "alias": "纵坐标",
                    "datatype": "java.lang.Double",
                },
                {
                    "name": "Z",
                    "alias": "高程",
                    "datatype": "java.lang.Double",
                }
            ]
        }],
    },
    /**
     * 查询指定工作空间是否存在
     * @param {string} service geoserver地址
     * @param {string} workspace 工作空间 
     */
    isExistWorkspace: function (service, workspace) {
        return this._isExistWorkspace(service, workspace)
    },
    /**
     * 查找指定数据库连接类型的数据存储
     * @param {string} service geoserver地址
     * @param {string} dbtype 数据库类型 PostGIS
     */
    findDatastore: async function (service, dbtype) {
        let workspacesRep = await axios.get(`${service}/rest/workspaces`)
        if (workspacesRep.data.workspaces.workspace && workspacesRep.data.workspaces.workspace.length > 0) {
            let count = workspacesRep.data.workspaces.workspace.length;
            for (let i = 0; i < count; i++) {
                let workspace = workspacesRep.data.workspaces.workspace[i].name;
                let datastoresRep = await axios.get(`${service}/rest/workspaces/${workspace}/datastores`)
                if (datastoresRep.data.dataStores.dataStore && datastoresRep.data.dataStores.dataStore.length > 0) {
                    let storeCount = datastoresRep.data.dataStores.dataStore.length;
                    for (let j = 0; j < storeCount; j++) {
                        let name = datastoresRep.data.dataStores.dataStore[j].name
                        let datastorRep = await axios.get(`${service}/rest/workspaces/${workspace}/datastores/${name}`)
                        if (datastorRep.data.dataStore.type == dbtype) {
                            let result = {};
                            datastorRep.data.dataStore.connectionParameters.entry.forEach(item => {
                                result[item["@key"]] = item["$"]
                            })
                            return result;
                        }
                    }
                }
            }
            return null
        } else return null
    },
    /**
     * 创建工作空间（包括存储、图层、图层组）
     * @param {*} option 
     */
    createWorkspace: async function (option) {
        try {
            let suffix = helper._getTempName("_");
            let dataStore = option.workspace + suffix;
            let namespaceUri = this.options.namespace_url + option.workspace;
            let status = await this._createEmptyWorkspace(option.service, option.workspace, namespaceUri);
            if (!status) throw new Error('创建新工作空间失败');
            try {
                status = await this._createDataStore(option, dataStore, namespaceUri);
                if (!status) {
                    throw new Error('创建存储失败')
                };
                status = await this._createLayers(option.service, option.workspace, dataStore, this.options.layers, suffix);
                if (!status) {
                    throw new Error('创建图层失败')
                };
                status = await this._createLayerGroup(option.service, option.workspace, suffix, this.options.layers)
                if (!status) {
                    throw new Error('创建图层失败')
                };
            } catch (error) {
                this.removeWorkspace(option.service, option.workspace);
                throw error;
            }
        } catch (error) {
            throw error;
        }
    },
    /**
     * 删除工作空间
     * @param {string} workspace
     */
    removeWorkspace: async function (service, workspace) {
        try {
            await axios.delete(`${service}/rest/workspaces/${workspace}?recurse=true`)
        } catch {}
    },
    /**
     * 创建工作空间（没图层）
     * @param {*} service 
     * @param {*} workspace 
     * @param {*} namespaceUri 
     */
    _createEmptyWorkspace: async function (service, workspace, namespaceUri) {
        let data = {
            namespace: {
                prefix: workspace,
                uri: namespaceUri
            }
        };
        let rep = await axios.post(`${service}/rest/namespaces`, data, {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        })
        if (rep.status == 201) return true;
        else return false;
    },
    /**
     * 创建存储
     * @param {*} option 
     * @param {*} dataStore 
     * @param {*} namespaceUri 
     */
    _createDataStore: async function (option, dataStore, namespaceUri) {
        let data = `<dataStore>
                    <name>${dataStore}</name>
                    <enabled>true</enabled>
                    <connectionParameters>
                      <entry key="Estimated extends">true</entry>
                      <entry key="database">${option.database}</entry>
                      <entry key="passwd">${option.passwd}</entry>
                      <entry key="port">${option.port}</entry>
                      <entry key="validate connections">true</entry>
                      <entry key="wkb enabled">true</entry>
                      <entry key="namespace">${namespaceUri}</entry>
                      <entry key="host">${option.host}</entry>
                      <entry key="dbtype">postgis</entry>
                      <entry key="loose bbox">true</entry>
                      <entry key="user">${option.user}</entry>
                      <entry key="Expose primary keys">true</entry>
                      <entry key="encode functions">true</entry>
                      <entry key="create database">true</entry>
                      <entry key="Support on the fly geometry simplification">true</entry>
                      <entry key="Loose bbox">true</entry>
                      <entry key="Test while idle">true</entry>
                    </connectionParameters>
                  </dataStore>`;
        let rep = await axios.post(`${option.service}/rest/workspaces/${option.workspace}/datastores`, data, {
            headers: {
                'Content-Type': 'application/xml;charset=utf-8',
            }
        });
        if (rep.status == 201) return true;
        else return false;
    },
    /**
     * 创建多个图层
     * @param {*} service 
     * @param {*} workspace 
     * @param {*} dataStore 
     * @param {*} layers 
     * @param {*} suffix 
     * @param {*} namespaceUri 
     */
    _createLayers: async function (service, workspace, dataStore, layers, suffix, namespaceUri) {
        for (let i = 0; i < layers.length; i++) {
            let status = await this._createLayer(service, workspace, dataStore, layers[i], suffix, namespaceUri);
            if (!status) return false;
        }
        return true;
    },
    /**
     * 创建单个图层
     * @param {*} workspace
     * @param {*} layer
     */
    _createLayer: async function (service, workspace, dataStore, layer, suff, namespaceUri) {
        let data = {
            "featureType": {
                "name": layer.name + suff,
                "nativeName": layer.name + suff,
                "namespace": {
                    "name": workspace,
                    "href": namespaceUri
                },
                "title": layer.title,
                "srs": this.options.srs,
                "nativeCRS": this.options.srs_content,
                "nativeBoundingBox": this.options.nativeBoundingBox,
                "latLonBoundingBox": this.options.latLonBoundingBox,
                "projectionPolicy": "FORCE_DECLARED",
                "enabled": true,
                "keywords": {
                    "string": layer.keywords ? layer.keywords.string : 'alias:' + JSON.stringify(layer.attribute.map(attr => {
                        return {
                            name: attr.name,
                            alias: attr.alias
                        }
                    }))
                },
                "metadata": {
                    "entry": {
                        "@key": "cachingEnabled",
                        "$": "false"
                    }
                },
                "store": {
                    "@class": "dataStore",
                    "name": workspace + ":" + dataStore,
                    "href": `${service}/rest/workspaces/${workspace}/datastores/${dataStore}.json`
                },
                "serviceConfiguration": false,
                "maxFeatures": 0,
                "numDecimals": 0,
                "padWithZeros": false,
                "forcedDecimal": false,
                "overridingServiceSRS": false,
                "skipNumberMatched": false,
                "circularArcPresent": false,
                "attributes": {
                    attribute: layer.attribute.map(item => {
                        return {
                            name: item.name,
                            minOccurs: 0,
                            maxOccurs: 1,
                            nillable: true,
                            binding: item.datatype
                        }
                    }).concat({
                        name: this.options.GEOField,
                        minOccurs: 0,
                        maxOccurs: 1,
                        nillable: true,
                        binding: layer.geotype
                    })
                }
            }
        };
        let rep = await axios.post(`${service}/rest/workspaces/${workspace}/datastores/${dataStore}/featuretypes`, data, {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        });
        if (rep.status == 201) return true;
        else return false
    },
    /**
     * 组织多图层到图层组
     * @param {*} service 
     * @param {*} workspace 
     * @param {*} suffix 
     * @param {*} layers 
     */
    _createLayerGroup: async function (service, workspace, suffix, layers) {
        let data = {
            layerGroup: {
                name: workspace + suffix,
                mode: "SINGLE",
                title: workspace + suffix,
                workspace: {
                    name: workspace
                },
                publishables: {
                    published: layers.map(item => {
                        return {
                            "@type": "layer",
                            "name": workspace + ":" + item.name + suffix
                        }
                    })
                },
                styles: {
                    style: layers.map(item => {
                        return {
                            name: item.style
                        }
                    })
                },
                bounds: this.options.nativeBoundingBox
            }
        };
        let rep = await axios.post(`${service}/rest/workspaces/${workspace}/layergroups`, data, {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        })
        if (rep.status == 201) return true;
        else return false;
    },
    /**
     * 加载指定工作空间的基础信息
     * @param {string} service GeoServer 主机地址
     * @param {string} workspace GeoServer 工作空间
     */
    initialize: function (service, workspace) {
        let self = this;
        return new Promise((resolve, reject) => {
            this._isExistWorkspace(service, workspace).then(isExistRep => {
                if (isExistRep) {
                    axios.all([axios.get(`${service}/rest/workspaces/${workspace}/layergroups`)])
                        .then(req => {
                            if (!(req[0].data.layerGroups.layerGroup instanceof Array)) throw '未获取到图层组';
                            self._findGroupLayers(req[0].data.layerGroups.layerGroup)
                                .then(data => {
                                    return self._findSubLayers(service, workspace, data);
                                }).then(data => {
                                    return self._findSubLayers(service, workspace, data);
                                }).then(data => {
                                    var layers = [];
                                    self._buildSublayer(layers, data.layers); //提取为一维子图层集合
                                    var layernames = layers.map(layer => workspace + ":" + layer.layertype);
                                    //根据图层的默认样式提取图层分类渲染信息
                                    self._findSublayerByStyle(service, workspace, layers).then(() => {
                                        resolve({
                                            workspace: workspace,
                                            layers: layers,
                                            ogc: {
                                                LAYERS: layernames.join(',')
                                            }
                                        });
                                    }).catch(error => {
                                        throw error
                                    });
                                }).catch(error => {
                                    reject(error);
                                }); //暂时只支持再嵌套一个图层组
                        }).catch(error => reject(error));
                } else {
                    reject(`查找:geoserver:${service}的工作空间${workspace}不存在`)
                }
            }).catch(error => reject(error));
        });
    },

    /**
     * 检查工作空间是否存在
     * @param {string} service GeoServer 主机地址
     * @param {string} workspace GeoServer 工作空间
     */
    _isExistWorkspace: function (service, workspace) {
        return new Promise((resolve, reject) => {
            axios.get(`${service}/rest/workspaces`).then(rep => {
                if (rep.data.workspaces.workspace.filter(item => item.name == workspace).length > 0)
                    resolve(true);
                else {
                    resolve(false);
                }
            }).catch(error => {
                reject(error)
            });
        });
    },

    /**查找图层组信息 */
    _findGroupLayers: function (layerGroups) {
        return new Promise((resolve, reject) => {
            let layerTask = layerGroups.map(layerGroup => {
                return axios({
                    url: layerGroup.href,
                    method: 'get'
                });
            });
            axios.all(layerTask).then(reps => {
                var layers = [];
                var sublayers = [];
                reps.forEach(rep => {
                    if (typeof rep.data.layerGroup.keywords != 'undefined' &&
                        rep.data.layerGroup.keywords.string.includes('hide')) {
                        //图层组配置有hide关键词时跳过此图层组,避免多个图层组的嵌套情况
                        return;
                    }
                    //记录图层组
                    layers.push({
                        visible: true, //后期可考虑用配置关键字方式配饰图层初始可见性
                        layertype: rep.data.layerGroup.name,
                        layername: rep.data.layerGroup.title,
                        extent: rep.data.layerGroup.bounds,
                        subnames: rep.data.layerGroup.publishables.published instanceof Array ? rep.data.layerGroup.publishables.published.map(item => item.name.split(':')[1]) : [rep.data.layerGroup.publishables.published.name.split(':')[1]]
                    });
                    var hrefs = rep.data.layerGroup.publishables.published instanceof Array ? rep.data.layerGroup.publishables.published : [rep.data.layerGroup.publishables.published];
                    sublayers = sublayers.concat(hrefs);
                })
                resolve({
                    layers: layers,
                    sublayers: sublayers
                });
            }).catch(error => {
                reject(error);
            });
        });
    },

    /**查找子图层信息 */
    _findSubLayers: function (url, workspace, data) {
        return new Promise((resolve, reject) => {
            if (data.sublayers.length == 0)
                resolve(data); //解析到没有子图层了
            let sublayerTask = data.sublayers.map(async layerItem => {
                var url = layerItem.href;
                if (layerItem['@type'] == 'layer') {
                    let response = await axios.get(url);
                    url = response.data.layer.resource.href;
                }
                return axios({
                    url: url,
                    method: 'get'
                });
            });
            var that = this;
            axios.all(sublayerTask).then(reps => {
                var sublayers = [];
                reps.forEach(rep => {
                    if (typeof rep.data.featureType != 'undefined') {
                        let layer = {
                            visible: true,
                            layertype: rep.data.featureType.name,
                            layername: rep.data.featureType.title,
                            extent: rep.data.featureType.latLonBoundingBox,
                            attribute: rep.data.featureType.attributes.attribute,
                            legend: `${url}/wms?REQUEST=GetLegendGraphic&LEGEND_OPTIONS=DPI:270;forceLabels:off&TRANSPARENT=true&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=${workspace}:${rep.data.featureType.name}&ts=${new Date().valueOf()}`
                        };
                        if (typeof rep.data.featureType.keywords != 'undefined' &&
                            rep.data.featureType.keywords.string.includes('hide')) {
                            //图层配置有hide关键词时,隐藏此图层
                            layer.visible = false;
                        }
                        that._attacheSublayer(data.layers, layer);
                    } else if (typeof rep.data.layerGroup != 'undefined') {
                        //会出现图层组嵌套图层组
                        let layer = {
                            visible: true, //后期可考虑用配置关键字方式配饰图层初始可见性
                            layertype: rep.data.layerGroup.name,
                            layername: rep.data.layerGroup.title,
                            extent: rep.data.layerGroup.bounds,
                            subnames: rep.data.layerGroup.publishables.published instanceof Array ? rep.data.layerGroup.publishables.published.map(item => item.name.split(':')[1]) : [rep.data.layerGroup.publishables.published.name.split(':')[1]]
                        };
                        var hrefs = rep.data.layerGroup.publishables.published instanceof Array ? rep.data.layerGroup.publishables.published : [rep.data.layerGroup.publishables.published];
                        sublayers = sublayers.concat(hrefs);
                        that._attacheSublayer(data.layers, layer);
                    }
                });
                resolve({
                    layers: data.layers,
                    sublayers: sublayers
                });
            }).catch(error => {
                reject(error);
            });
        });
    },

    /**查找嵌套子图层组信息 */
    _attacheSublayer: function (layers, sublayer) {
        var name = sublayer.layertype;
        layers.forEach(layer => {
            if (typeof layer.subnames !== 'undefined' && layer.subnames.includes(name)) {
                if (typeof layer.sublayers == 'undefined')
                    layer.sublayers = [sublayer];
                else layer.sublayers.push(sublayer);
            }
            if (typeof layer.sublayers != 'undefined')
                this._attacheSublayer(layer.sublayers, sublayer);
        })

    },

    /**
     * 检索出所有非图层组图层集合
     */
    _buildSublayer(types, layerArray) {
        layerArray.forEach(item => {
            if (typeof item.sublayers == 'undefined')
                types.push(item);
            else {
                this._buildSublayer(types, item.sublayers);
            }
        });
    },

    /**
     *对多个图层根据图层的默认样式提取图层分类渲染信息
     * @param {Array<object>} layers
     */
    _findSublayerByStyle: function (url, workspace, layers) {
        //查询默认样式名
        //获取默认样式
        //提取渲染分类信息
        let self = this;
        return new Promise(function (resolve, reject) {
            let layerStyleTask = layers.map(layer => {
                return axios({
                    method: 'get',
                    url: `${url}/rest/workspaces/${workspace}/layers/${layer.layertype}`
                });
            });
            //查询图层样式
            axios.all(layerStyleTask).then(layerreps => {
                layerreps.forEach(layerrep => {
                    if (layerrep.status != 200) throw '查询图层样式失败';
                });
                let getStyleTask = [];
                layerreps.forEach(layerrep => {
                    //是否设置为默认样式，否则只是增加了临时可选样式
                    getStyleTask.push(axios({
                        method: 'get',
                        url: `${url}/rest/styles/${layerrep.data.layer.defaultStyle.name}`,
                        headers: {
                            'Accept': 'application/vnd.ogc.sld+xml',
                        }
                    }));
                });
                //获取默认style文件内容
                axios.all(getStyleTask).then(getStyleReps => {
                    getStyleReps.forEach(getStyleRep => {
                        if (getStyleRep.status != 200) throw '获取默认样式失败';
                    });
                    for (let i = 0; i < getStyleReps.length; i++) {
                        let sublayers = self._findSubtyleFromXML(getStyleReps[i].data);
                        sublayers.forEach(sublayer => sublayer.layertype = layers[i].layertype);
                        layers[i]['sublayers'] = sublayers;
                    }
                    resolve();
                }).catch((error) => {
                    throw error;
                });
            }).catch((error) => {
                reject(error);
            });
        });
    },

    /**
     *对单个图层的默认样式提取子图层信息
     * @param {*} xml
     */
    _findSubtyleFromXML: function (xml) {
        let xmlDoc = this._getXMLDoc(xml);
        let ridNodes = null;
        let prefix = '';
        if (xmlDoc.getElementsByTagName("Rule").length > 0)
            ridNodes = xmlDoc.getElementsByTagName("Rule");
        else {
            ridNodes = xmlDoc.getElementsByTagName("sld:Rule");
            prefix = 'sld:';
        }
        let subtypes = [];
        for (let i = 0, len = ridNodes.length; i < len; i++) {
            if (ridNodes[i].getElementsByTagName("ogc:PropertyName").length == 0) break;
            let title = ridNodes[i].getElementsByTagName(prefix + "Title")[0].childNodes[0].textContent;
            let subtype = {
                layername: title,
                title: title,
                visible: true,
                properties: null
            };
            let filters = ridNodes[i].getElementsByTagName('ogc:Filter');
            if (filters.length > 0) {
                let childNodes = Array.prototype.filter.call(filters[0].childNodes, item => item.nodeType == 1)
                if (childNodes.length > 0 && childNodes[0].tagName == 'ogc:And') {
                    let equalnodes = childNodes[0].getElementsByTagName('ogc:PropertyIsEqualTo');
                    if (equalnodes.length > 0) {
                        let properties = {};
                        for (let j = 0, lenj = equalnodes.length; j < lenj; j++) {
                            properties[equalnodes[j].getElementsByTagName('ogc:PropertyName')[0].textContent] =
                                equalnodes[j].getElementsByTagName('ogc:Literal')[0].textContent;
                        }
                        subtype.properties = properties;
                    }
                } else if (childNodes.length > 0 && childNodes[0].tagName != 'ogc:And')
                    subtype.properties = null; //其他类型的符号
                else if (childNodes.length == 0)
                    subtype.properties = undefined; //没有过滤条件的符号
            }
            subtypes.push(subtype);
        }
        return subtypes;
    },

    /**
     * 获取解析xml的工具
     * @param {xml格式的字符串}} txt
     */
    _getXMLDoc: function (txt) {
        if (typeof txt != 'string') throw '输入的不是XML';
        if (window.DOMParser) {
            var parser = new DOMParser();
            return parser.parseFromString(txt, "text/xml");
        }
    },
}

export default Init